import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { buildInfo } from '../../build-info';
import { environment } from '../../environments/environment';
import { UpdateCheckService } from '../services/update-check.service';

/**
 * Stamps every API request with the frontend build version (X-Client-Version) so
 * the backend can reject writes from a stale tab (see ClientVersionMiddleware),
 * and turns the resulting 426 Upgrade Required into a blocking reload prompt.
 *
 * Only API calls (environment.apiUrl) are stamped; /version.json and Keycloak
 * traffic are left untouched.
 */
export const clientVersionInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const versioned = req.clone({
    setHeaders: { 'X-Client-Version': buildInfo.version }
  });

  const updateCheck = inject(UpdateCheckService);

  return next(versioned).pipe(
    catchError((error: HttpErrorResponse) => {
      // 426 Upgrade Required: this client is older than the deployed frontend and
      // the backend refused the write. Force the user onto the current version.
      if (error.status === 426) {
        updateCheck.forceUpdateRequired();
      }
      return throwError(() => error);
    })
  );
};
